import { Modal } from 'antd';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

import { Colors } from '../../themes/Colors';
import ButtonGradient from '../button-gradient';
import { translate } from '../../helper';

export const SuccessModal = ({ open, onClose, data, role, isUpdate = false }) => {
  const getMessage = () => {
    if (!isUpdate) {
      return role === 'Child Account'
        ? 'Location is now active. Orders can now be created for this location.'
        : 'Welcome To MOVE - MAKE. ORDERING. VERY. EASY';
    }

    return role === 'Child Account'
      ? 'Location subscription updated successfully. Orders will continue for this location.'
      : 'Your master account subscription has been updated successfully';
  };
  return (
    <Modal visible={open} footer={<div />} centered closeIcon={<div />} style={{}} width={'calc(var(--fs-hero)*14.150943)'}>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column'
        }}>
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            padding: 'var(--sp-md2)'
          }}>
          <CheckCircleIcon
            style={{
              color: Colors.primary,
              fontSize: 'calc(var(--fs-hero)*1.4150943)'
            }}
          />
        </div>
        <div
          style={{
            color: Colors.primary,
            fontSize: 'calc(var(--fs-xl)*1.132075)',
            textAlign: 'center',
            lineHeight: 'calc(var(--fs-xl)*1.4150943)',
            fontWeight: 600
          }}>
          Congratulations
        </div>
        <div
          style={{
            color: '#383938',
            fontSize: 'calc(var(--fs-xs)*1.50943)',
            textAlign: 'center',
            lineHeight: 'calc(var(--fs-xl)*1.132075)',
            fontWeight: 400
          }}>
          {getMessage()}
        </div>
        <table
          style={{
            width: '90%',
            marginTop: 'var(--sp-lg)',
            marginLeft: 'auto',
            marginRight: 'auto'
          }}>
          <tr>
            <td style={{ padding: 'var(--sp-lg) 0', width: '50%', fontSize: 'calc(var(--fs-xs)*1.32075)'}}>Subscription</td>
            <td style={{ padding: 'var(--sp-lg) 0', fontSize: 'calc(var(--fs-xs)*1.32075)', fontWeight: 600}}>{data?.name}</td>
          </tr>
          {data?.noOfChildAccount ? (
            <tr>
              <td style={{ padding: 'var(--sp-lg) 0', width: '50%', fontSize: 'calc(var(--fs-xs)*1.32075)' }}>Total Locations Paid</td>
              <td style={{ padding: 'var(--sp-lg) 0', fontSize: 'calc(var(--fs-xs)*1.32075)', fontWeight:600 }}>{data?.noOfChildAccount}</td>
            </tr>
          ) : (
            <></>
          )}
          <tr>
            <td style={{ padding: 'var(--sp-lg) 0', width: '50%', fontSize: 'calc(var(--fs-xs)*1.32075)' }}>Amount</td>
            <td style={{ padding: 'var(--sp-lg) 0', fontSize: 'calc(var(--fs-xs)*1.32075)', fontWeight: 600 }}>{`$ ${
              data?.noOfChildAccount ? data.amount * data?.noOfChildAccount : data?.amount
            }/${translate(data?.interval)}`}</td>
          </tr>
        </table>
        <ButtonGradient
          title="OK"
          style={{
            width: '100%'
          }}
          onClick={onClose}
        />
      </div>
    </Modal>
  );
};
